import QRCode from "react-qr-code";

/**
 * @param {object} params
 * @param {OnlineOrder} params.onlineOrder
 * @param {"md" | "lg"} params.size
 * @param {string} [params.phoneNumber]
 * @returns {React.Component}
 */
const OnlineOrderPaymentQrCode = ({ onlineOrder, size, phoneNumber = "" }) => {
  // Build a URL to the CyberPass order page so the customer lands on the
  // order confirmation page rather than going straight to PayKeeper.
  const params = new URLSearchParams({
    minutesAmount: String(onlineOrder.minutesAmount),
    priceRub: String(onlineOrder.priceRub),
    phoneNumber,
    orderId: onlineOrder.id,
    paymentUrl: onlineOrder.paymentUrl,
  });
  const url = `${window.location.origin}/order?${params.toString()}`;
  console.log(`Online order QR-code value: ${url}`);

  if (size === "md") {
    return (
      <div className={`p-4 rounded-xl bg-white w-fit mx-auto`}>
        <QRCode size={180} value={url} fgColor="#000" bgColor="#fff" />
      </div>
    );
  } else if (size === "lg") {
    return (
      <div className={`p-8 rounded-[50px] bg-white w-fit mx-auto`}>
        <QRCode size={500} value={url} fgColor="#000" bgColor="#fff" />
      </div>
    );
  } else {
    throw new Error(`Unknown size=${size}`);
  }
};

export default OnlineOrderPaymentQrCode;
